import { CardType } from "./CardType";
import { FeedbackHeroCard } from "./FeedbackHeroCard";
import { FeedbackThumbnailCard } from "./FeedbackThumbnailCard";
import { ICard } from "./ICard";
import { MessageType } from "./MessageType";
import { NotificationHeroCard } from "./NotificationHeroCard";
import { NotificationThumbnailCard } from "./NotificationThumbnailCard";

export class CardFactory {
    
    CreateCard(
        messageType: MessageType,
        cardType: CardType,
        userData: any
    ): ICard {
        if (messageType === MessageType.Feedback && cardType === CardType.Thumbnail){
            return new FeedbackThumbnailCard(userData);
        }
        
        if (messageType === MessageType.Feedback && cardType === CardType.Hero){
            return new FeedbackHeroCard(userData);
        }

        if (messageType === MessageType.Notification && cardType === CardType.Thumbnail){
            return new NotificationThumbnailCard(userData);
        }
        
        // messageType === "Notification" && cardType === "Hero"
        return new NotificationHeroCard(userData);
    }
}